// Get the the EM YTK blocks config data
// @ts-ignore
const config = window.emYtkBlocksConfig;
  
export default config;
